export const ENABLE_C3_TO_C5_DRUGS = "EnableC3toC5Drugs";
export const INVENTORY_LOCATIONS = "InventoryLocations";
export const BACK_COUNT = "BackCount";
export const COMPOUNDING = "Compounding";